import { getURLParams } from 'Actions/search';

const currentQueryParamsResponse = id => Promise.resolve({ queryParams: getURLParams(id) });

export const setUrl = data => (dispatch, getState) => {
    // Overrides all parameters
    dispatch({ type: 'SET_URL', payload: { ...data, propertyCode: data.propertyCode ? data.propertyCode : null } });
    return currentQueryParamsResponse(getState().url);
};

export const updateUrl = data => async (dispatch, getState) => {
    // Update only parameters in data
    await dispatch({ type: 'UPDATE_URL', payload: data });
    return currentQueryParamsResponse(getState().url);
};

export const updateAndRemoveUrl = data => async (dispatch, getState) => {
    // Update only url with parameters in data and remove if not exist in data
    await dispatch({ type: 'UPDATE_AND_REMOVE_URL', payload: data });
    return currentQueryParamsResponse(getState().url);
};
